import React, { useState, useEffect } from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import {
  blueTheme,
  brownTheme,
  purpleTheme,
  greenTheme,
  redTheme,
  blackTheme,
  pinkTheme,
  violetTheme,
  tealTheme,
  orangeTheme,
  yellowTheme,
  materialDarkTheme,
  materialLightTheme,
  materialTealTheme,
} from "./theme";
import { GlobalStyles } from "./global";

const themes = [
  blueTheme,
  brownTheme,
  purpleTheme,
  greenTheme,
  redTheme,
  blackTheme,
  pinkTheme,
  violetTheme,
  tealTheme,
  orangeTheme,
  yellowTheme,
  materialDarkTheme,
  materialLightTheme,
  materialTealTheme,
];

function App() {
  const [themeIndex, setThemeIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [alertDismissed, setAlertDismissed] = useState(false);

  useEffect(() => {
    const themeInterval = setInterval(() => {
      setThemeIndex((prevIndex) => (prevIndex + 1) % themes.length);
    }, 3000);
    return () => clearInterval(themeInterval);
  }, []);

  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
      setIsMobile(mobileRegex.test(userAgent));
    };

    checkIfMobile();

    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const currentTheme = themes[themeIndex];

  const dismissAlert = () => {
    setAlertDismissed(true);
  };

  return (
    <ThemeProvider theme={currentTheme}>
      <>
        <GlobalStyles />
        {isMobile && !alertDismissed && (
          <div
            className="mobile-alert"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: currentTheme.highlight || "#fff",
              color: currentTheme.text || "#000",
              padding: "15px",
              textAlign: "center",
              zIndex: 9999,
              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            <p style={{ margin: "0 0 10px 0" }}>
              <strong>Best viewed on desktop</strong>
              <br />
              For the full experience of the collections, view from a larger
              screen.
            </p>
            <button
              onClick={dismissAlert}
              style={{
                backgroundColor: currentTheme.text || "#000",
                color: currentTheme.body || "#fff",
                border: "none",
                padding: "8px 15px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              I understand
            </button>
          </div>
        )}
        <div>
          <Main theme={currentTheme} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
